// extracted by mini-css-extract-plugin
export default {"section":"reportsSummary_section__6ullB","listRow":"reportsSummary_listRow__-HEz4"};